module.exports = __webpack_public_path__ + "html/section-video-gallery_59bec7c61b9fc5701eec9ccd9f5dd645.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/landing-template/components/sections/section-video-gallery.html
// module id = lU18
// module chunks = 82